const messages = {
  threads: {
    orders: {
      title: "Votre commande dans la boutique récompenses",
      content:
        "<p>Cher client,</p>\n<p>&nbsp;</p>\n<p>Merci pour votre commande dans la boutique r&eacute;compenses :</p>\n<p>- &nbsp;&gt;&gt;ORDER-ID&lt;&lt;&nbsp;</p>\n<p>- &nbsp;&gt;&gt;ORDER-PRODUCTS&lt;&lt;&nbsp;</p>\n<p>Votre commande est en cours de traitement.<br>La livraison peut prendre jusqu'&agrave; 3 semaines.</p>\n<p>Cordialement</p>\n<p>Votre &eacute;quipe BRIDGESTONE PLUS</p>",
    },
    externalTraining: { title: "", content: "" },
    InvestmentSupport: { title: "", content: "" },
    onlineTraining: {
      title: "Votre participation à la formation en ligne",
      content:
        "<p>Cher client,</p>\n<p>&nbsp;</p>\n<p>Merci d'avoir participé à la formation en ligne <strong>&nbsp;&gt;&gt;ONLINE_TRAINING_TITLE&lt;&lt ;</ strong> &nbsp;et le quiz.</p>\n<p>Si vous avez répondu correctement à toutes les questions du quiz, vous avez reçu un crédit de 40 points de récompense.<br />Félicitations.<br /> <br />Remarque : Vous pouvez participer au quiz correspondant une fois pour chaque formation en ligne proposée et obtenir des points de récompense.<br /><br />Meilleures salutations<br /><br / >Votre équipe BRIDGESTONE PLUS&nbsp;<br /><br / ></p>",
    },
    bTraining: {
      title: "Votre participation à la formation en ligne",
      content:
        "<p>Cher client,</p>\n<p>&nbsp;</p>\n<p>Merci pour votre participation &agrave; la formation en ligne &gt;&gt;ONLINE_TRAINING_TITLE&lt;&lt; &nbsp;et au quiz.</p>\n<p>En r&eacute;pondant correctement &agrave; toutes les questions du quiz, vous recevrez un cr&eacute;dit de 40 points de r&eacute;compense.<br>F&eacute;licitations.</p>\n<p>Remarque : vous pouvez participer au quiz correspondant une fois pour chaque formation en ligne propos&eacute;e et obtenir les points bonus.</p>\n<p>Cordialement</p>\n<p>Votre &eacute;quipe BRIDGESTONE PLUS</p>",
    },
    hunter: { title: "", content: "" },
    profileComplete: {
      title: "Profil complété - félicitations",
      content:
        "<p>Cher client,</p>\n<p>&nbsp;</p>\n<p>Vous avez compl&eacute;t&eacute; votre profil utilisateur !</p>\n<p>Nous tenons &agrave; vous remercier beaucoup avec 200 points de r&eacute;compense,<br>qui ont d&eacute;j&agrave; &eacute;t&eacute; cr&eacute;dit&eacute;s sur votre compte de points.</p>\n<p><br>Cordialement</p>\n<p>Votre &eacute;quipe BRIDGESTONE PLUS</p>",
    },
    activeUser: { title: "", content: "" },
    deleteItemFromOrder: { title: "", content: "" },
    deleteOrder: { title: "", content: "" },
    commitmentLetter: { title: "", content: "" },
    uberall: { title: "", content: "" },
    welcome: { title: "", content: "" },
    booster: {
      title: "Vos doubles points marketing sont désormais activés!",
      content:
        "Cher utilisateur, vous recevrez des points booster. Vérifiez votre relevé bancaire.",
    },
    orderStatus_RETURNED: { title: "", content: "" },
    orderStatus_REJECTED: { title: "", content: "" },
    kickbackPayback: { title: "", content: "" },
    survey_thankyou: { title: "", content: "" },
    survey: { title: "", content: "" },
    salesPromotions: {
      title: "Promotions des ventes - votre demande",
      content:
        "<p>Cher client,</p>\n<p>&nbsp;</p>\n<p>Merci pour votre demande et votre int&eacute;r&ecirc;t pour nos promotions commerciales.</p>\n<p>Vous &ecirc;tes inscrit &agrave; la ou aux promotions suivantes :</p>\n<p>&nbsp;</p>\n<p>&gt;&gt;USER_PROMOTIONS&lt;&lt;</p>\n<p>&nbsp;</p>\n<p>Votre entreprise sera ajout&eacute;e au localisateur de revendeurs pour la ou les promotions dans les 14 prochains jours et le mat&eacute;riel promotionnel pour votre salle de vente vous sera envoy&eacute; dans un d&eacute;lai de 2 &agrave; 3 semaines.</p>\n<p>&nbsp;</p>\n<p>Nous vous souhaitons beaucoup de succ&egrave;s dans nos campagnes.</p>\n<p><br>Votre &eacute;quipe BRIDGSTONE PLUS</p>",
    },
  },
};

export default {
  messages,
};
